<script setup>
const emit = defineEmits(['toggle'])
const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
  isLast: {
    type: Boolean,
    required: false,
    default: false,
  },
  size: {
    type: String,
    required: false,
    default: 'md',
  },
})

function toggleAccordion() {
  emit('toggle', props.index)
}
</script>

<template>
  <div
    class="bg-white"
    :class="[
      { 'p-0': size === 'sm' },
      {
        'p-4': size !== 'sm',
        'border-b border-gray-200 last:border-b-0': !isLast,
      },
    ]"
  >
    <div
      class="flex w-full cursor-pointer items-center justify-between font-sans font-semibold text-gray-900"
      :class="{ 'py-4': !isLast, 'pt-4': isLast }"
      :aria-expanded="isOpen"
      :aria-controls="`collapse${index}`"
      @click="toggleAccordion()"
    >
      <slot name="title" />

      <IconChevronDown
        class="w-[10px] transition-transform duration-300 ease-in-out"
        :class="{ '-rotate-180': isOpen }"
      />
    </div>

    <HeightTransition>
      <div v-if="isOpen">
        <div
          :id="`collapse${index}`"
          class="text-base"
          :class="{ 'pb-4': !isLast, 'pt-4': isLast }"
        >
          <slot name="content" />
        </div>
      </div>
    </HeightTransition>
  </div>
</template>
